import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

export enum MessageType {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  SUCCESS = 'success'
}

@Component({
  selector: 'alert-message',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertComponent implements OnInit {
  @Input() messageType: MessageType = MessageType.INFO;

  alertCssClass: string;

  constructor() { }

  ngOnInit() {
    this.alertCssClass = `alert alert-${this.messageType}`;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/alert/alert.component.ts